import classNames from "classnames/bind";
import React, { type HTMLAttributes, type ReactNode } from "react";
import styles from "./SelectionActionBanner.module.scss";

const cx = classNames.bind(styles);

export const SelectionActionBanner = ({
  selectedCount,
  isAllSelected = false,
  isAllSelectionEnabled = false,
  totalCount,
  onSelectionAllChange,
  actions,
  visibleTableWidth,
  selectionCheckboxWidth,
  className,
  style,
}: {
  selectedCount: number;
  totalCount: number;
  isAllSelected?: boolean;
  isAllSelectionEnabled?: boolean;
  onSelectionAllChange?: (isAllSelected: boolean) => void;
  actions?: ReactNode[];
  visibleTableWidth: number;
  selectionCheckboxWidth: number;
} & Pick<HTMLAttributes<HTMLDivElement>, "className" | "style">) => {
  const showSelectAll = !isAllSelected && selectedCount < totalCount;

  return (
    <div
      className={cx("banner", className)}
      style={{
        width: visibleTableWidth - selectionCheckboxWidth - 1,
        left: selectionCheckboxWidth + 1,
        ...style,
      }}
    >
      <div className={cx("selections-container")}>
        <p className={cx("current-selection-info")}>
          <span className={cx("count-highlight")}>{selectedCount}</span> items
          selected.
        </p>
        <button
          className={cx("select-all-trigger")}
          onClick={() => {
            if (isAllSelectionEnabled && showSelectAll) {
              // toggle
              onSelectionAllChange?.(!isAllSelected);
            } else {
              // unselect all
              onSelectionAllChange?.(false);
            }
          }}
        >
          {isAllSelectionEnabled && showSelectAll ? (
            <>Select all {totalCount} items in table</>
          ) : (
            <>Unselect all</>
          )}
        </button>
      </div>
      <div className={cx("actions-container")}>{actions}</div>
    </div>
  );
};
